<div class="modal-overlay" *ngIf="showModal" (click)="!salvando && fecharModal()">
  <div class="box-novo-compromisso" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">Novo Compromisso</h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="salvando"></button>
      </div>
    </div>
    <hr>
    <form [formGroup]="formNovoCompromisso">
      <fieldset [disabled]="salvando" class="border-0 p-0 m-0">
      <div class="row g-3">
        <div class="col-md-12">
          <label for="descricao" class="form-label">Descrição</label>
          <input type="text" id="descricao" class="form-control" formControlName="descricao"
                 placeholder="Digite o título do compromisso"
                 [ngClass]="{'is-invalid': formNovoCompromisso.controls['descricao'].invalid && formNovoCompromisso.controls['descricao'].touched}">
        </div>
        <div class="col-md-12">
          <label for="processoId" class="form-label">Processo</label>
          <ng-select [items]="processos.itens"
                     bindLabel="titulo"
                     bindValue="id"
                     formControlName="processoId"
                     placeholder="Selecione"
                     id="processoId">
          </ng-select>
        </div>
        <div class="col-md-6">
          <label for="dataInicial" class="form-label">Data Início</label>
          <input type="datetime-local" class="form-control"
                 formControlName="dataInicial"
                 id="dataInicial"
                 [ngClass]="{'is-invalid': formNovoCompromisso.controls['dataInicial'].invalid && formNovoCompromisso.controls['dataInicial'].touched}">
        </div>
        <div class="col-md-6">
          <label for="dataFinalizacao" class="form-label">Data Final</label>
          <input type="datetime-local" class="form-control"
                 formControlName="dataFinalizacao"
                 id="dataFinalizacao"
                 [ngClass]="{'is-invalid': formNovoCompromisso.controls['dataFinalizacao'].invalid && formNovoCompromisso.controls['dataFinalizacao'].touched}">
        </div>
        <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
          <button type="button" class="btn btn-light" (click)="fecharModal()" [disabled]="salvando">Cancelar</button>
          <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="salvando || formNovoCompromisso.invalid">
            <span *ngIf="salvando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ salvando ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
      </fieldset>
    </form>
  </div>
</div>
